"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInRole = isInRole;

function isInRole(role, user) {
  if (user) {
    var _user$role;

    return Array.isArray(user.role) ? (_user$role = user.role) === null || _user$role === void 0 ? void 0 : _user$role.includes(role) : user.role === role;
  }

  return false;
}